import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";

export const ImageFrame = ({
  src,
  alt,
  className = "",
  imgClassName = "",
  arch = false,
  parallax = 0,
  ratio = "aspect-[4/5]",
}) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-parallax, parallax]);
  // scroll-through settle: image breathes from slightly zoomed to fit as it
  // passes the viewport center — cheap transform-only scroll animation.
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.14, 1.06, 1.14]);

  return (
    <div
      ref={ref}
      className={`group relative overflow-hidden bg-sand ${arch ? "arch-frame" : "rounded-[18px]"} ${ratio} ${className}`}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={reduce ? undefined : parallax ? { y, scale } : { scale }}
        className={`h-full w-full object-cover will-change-transform ${imgClassName}`}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-espresso/25 via-transparent to-transparent opacity-60" />
    </div>
  );
};
